// ** Gatsby
import { GatsbyImage } from "gatsby-plugin-image"

// ** Custom Components
import Box from "../../Box"
import Container from "../../Container"
import Text from "../../Text"
import Heading from "../../Heading"
import { PortableText } from "@portabletext/react"
import Button from "../../Button"
import { serializers } from "../../Serializers"
import SectionLink from "../../SectionLink"

const SectionHero = ({ section }: any) => {
  const {
    Heading: heading,
    tagline,
    background,
    tags,
    linkPrimary,
    disclaimer,
  } = section
  const content = section?._rawContent
  const newHero = tags.includes("new-hero")

  if (background?.Image) {
    return (
      <Container
        className="pt-10 lg:pt-12 flex flex-col lg:flex-row lg:flex-row-reverse gap-10"
        fullWidthOnMobile={false}
        constrainedToBreakPoint
      >
        <Box className={`${newHero ? "lg:basis-[50%]" : "lg:basis-[65%]"}`}>
          <GatsbyImage
            image={background?.Image?.asset?.gatsbyImageData}
            alt={background?.Image?.asset?.altText || "hero"}
          />
        </Box>
        <Box className="text-gray-700 text-center lg:flex-1 lg:text-left">
          <Box
            className={`px-4 lg:px-0 w-full lg:mt-8 ${
              tagline?.length < 100 ? (newHero ? "" : "lg:w-64") : ""
            }`}
          >
            <Heading className="text-blue-500 whitespace-pre-line inline-block">
              {heading}
            </Heading>
            <Text
              className={`${newHero && "text-blue-500 "} mt-4 lg:mt-8 lg:mb-8`}
            >
              {tagline}
            </Text>
            <PortableText value={content} components={serializers} />
            {linkPrimary && (
              <SectionLink link={linkPrimary}>
                <Button className="bg-orange-500 max-w-max text-white py-4 px-8 lg:fluid-lg mt-4">
                  {linkPrimary?.title}
                </Button>
              </SectionLink>
            )}
            {disclaimer && (
              <Text className={`text-[12px] mt-4 lg:mt-8 lg:mb-8`}>
                {disclaimer}
              </Text>
            )}
          </Box>
        </Box>
      </Container>
    )
  } else {
    return (
      <Container
        className="pt-10 lg:pt-12"
        fullWidthOnMobile={false}
        constrainedToBreakPoint
      >
        <Box className="text-gray-700 text-center lg:max-w-[80%] mx-auto">
          <Heading className="text-blue-500 whitespace-pre-line">
            {heading}
          </Heading>
          <Text className="mt-4 lg:mt-8 lg:mb-10">{tagline}</Text>
        </Box>
      </Container>
    )
  }
}

export default SectionHero
